import React from 'react'
import { memoryConverter } from './memoryConverter'

interface Props {
    value: string | number
    decimals: number
    class: string
    showPlusSign: boolean
    boldUnit: boolean
}
class Memory extends React.Component<Props> {
    public static defaultProps = {
        value: 0,
        decimals: 1,
        class: 'memory',
        showPlusSign: false,
        boldUnit: true,
    }

    public render() {
        const className = this.props.boldUnit ? 'unit ' + this.props.class : this.props.class
        let value = this.props.value
        const { showPlusSign } = this.props

        if (!value || value === '0') {
            return <span className={className}>0 Byte</span>
        }

        if (typeof value === 'string') {
            value = parseInt(value, 10)
        }

        const showSign = value >= 0 && showPlusSign ? '+' : ''
        return (
            <span className={className}>
                {showSign}
                {memoryConverter(value)}
            </span>
        )
    }
}

export default Memory
